import { useTranslation } from 'react-i18next';

import { ConnectionFallback } from '../ConnectionFallback';

interface ConnectToWhatsappProps {
  description: string;
  to: string;
}

export const ConnectToWhatsapp = ({ to, description }: ConnectToWhatsappProps) => {
  const { t } = useTranslation('anychat');

  return (
    <ConnectionFallback
      imgSrc="/assets/anychat/connect-anychat.png"
      imgAlt={t('anychat.shared.connectToWhatsapp.alt')}
      title={t('anychat.shared.connectToWhatsapp.title')}
      description={description}
      link={to}
      linkLabel={t('anychat.shared.connectToWhatsapp.link')}
    />
  );
};
